interface IRequestCameraPermissionOptions {
  onGrantedCb: () => void;
  onErrorCb: (error: unknown) => void;
}

/**
 * This uses the browser navigator media devices to request access to the camera.
 */
export const requestCameraPermission = async ({
  onGrantedCb,
  onErrorCb,
}: IRequestCameraPermissionOptions) => {
  try {
    const stream = await navigator.mediaDevices.getUserMedia({
      video: true,
    });
    stream.getTracks().forEach((track) => track.stop());

    if (stream) {
      onGrantedCb();
    } else {
      onErrorCb('Camera access possible but no data stream.');
    }
  } catch (error) {
    onErrorCb(error);
  }
};
